import { Box } from '@mui/material';
import { Icon } from '@components/Icon';
import { Hint } from '@components/Hint';
import colors from '@styles/colors.module.scss';
import { Column } from '@components/Table/types';
import { ResponseItem } from './hooks/useGetResponses';

export const getColumns = (): Column<ResponseItem>[] => [
  {
    title: 'Название вакансии',
    dataIndex: 'name',
    sx: { whiteSpace: 'normal' },
  },
  {
    title: 'Студент',
    dataIndex: 'userName',
    sx: { whiteSpace: 'normal' },
  },
  {
    title: 'Статусы',
    dataIndex: 'stage',
    sx: { whiteSpace: 'normal' },
    render: (value, record) => (
      <Box component="pre" sx={{ whiteSpace: 'pre-wrap', margin: 0, fontFamily: 'inherit' }}>
        {record.history?.map((h) => `${h.date} ${h.stage};`).join('\n')}
      </Box>
    ),
  },
  {
    title: 'Отказ',
    align: 'center',
    dataIndex: 'refused',
    width: '72px',
    render: (value: boolean, record) =>
      value ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          {record.refuseReason ? (
            <Hint title={record.refuseReason} variant="error">
              <Box display="flex">
                <Icon name="close" htmlColor={colors.error} />
              </Box>
            </Hint>
          ) : (
            <Icon name="close" htmlColor={colors.error} />
          )}
        </Box>
      ) : null,
  },
];
